import { styled, Box } from '@mui/material';
import { theme } from 'assets/themes/zizzi';

export const Wrapper = styled(Box)`
  height: 100%;
  position: relative;
`;

export const StyledBody = styled(Box)`
  display: flex;
  min-height: 100%;
  padding-top: 56px;

  ${theme.breakpoints.up('md')} {
    padding-top: 64px;
  }
`;
